import { Button, ButtonGroup, ButtonLink } from '@design-system-etat/dsfr-react';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import RoutesRepriseDonnees from './CorrigerArme/routes';
import { getPath } from '../../../../../../utils/router';

const BoutonsAction = ({ handleClickAfficherModal, repriseDeDonneesUuid, numeroSerie }) => {
    const handleClickButton = () => {
        handleClickAfficherModal(repriseDeDonneesUuid);
    };

    const urlModifierArme = getPath(RoutesRepriseDonnees, {
        uuidArmeSelec: repriseDeDonneesUuid,
    });

    return (
        <ButtonGroup align="right" inline>
            <ButtonLink as={Link} to={urlModifierArme} variant="secondary" icon="fr-fi-edit-line">
                Complément ou correction de l'arme {numeroSerie ?? ''}
            </ButtonLink>
            <Button
                icon="fr-fi-delete-line"
                variant="secondary"
                onClick={handleClickButton}
                aria-label={`Suppression de l'arme ${numeroSerie ?? ''}`}
            >
                Suppression
            </Button>
        </ButtonGroup>
    );
};

BoutonsAction.propTypes = {
    handleClickAfficherModal: PropTypes.func.isRequired,
    repriseDeDonneesUuid: PropTypes.string.isRequired,
    numeroSerie: PropTypes.string,
};

export default BoutonsAction;
